import {
  TENANT_LIST,
  CREATE_TENANT,
  ALL_USERS,
  UPDATE_PROFILE,
  CREATE_USER,
  GET_PROFILES,
} from 'src/redux/Actions/Type';
const initialState = {
  tenantList: [],
  createUser: {},
  createTenant: {},
  allUsers: [],
  updateProfile: {},
  profileList: [],
};
const TenantReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case TENANT_LIST:
      return {
        ...state,
        tenantList: payload,
      };
    case CREATE_TENANT:
      return {
        ...state,
        createTenant: payload,
      };
    case ALL_USERS:
      return {
        ...state,
        allUsers: payload,
      };
    case UPDATE_PROFILE:
      return {
        ...state,
        updateProfile: payload,
      };
    case CREATE_USER:
      return {
        ...state,
        createUser: payload,
      };
    case GET_PROFILES:
      return {
        ...state,
        profileList: payload,
      };
    default:
      return state;
  }
};
export default TenantReducer;
